/**eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

/**Common components */
import Label from "../../../../components/ui/label/Label";
import ToolbarButtons from "../../../../components/toolbarButtons/ToolbarButtons";
import { getDropdownValue } from "../../../../components/finalForms/libs/data/dropdownUtilities";

/**Config File */
import { pendingContractToolbarConfig } from "./PendingContract.toolbar.config";
/**Context */
import { PendingContractProvider } from "../../../../utils/context/PendingContractContext";

/** Services */
import ToastService from "../../../../services/toastService/ToastService";
import SwalAlert from "../../../../services/swalService/SwalService";

/** RTK Query */
import { useDeletePendingContractMutation, useGetPendingContractsListMutation, useUpdatePendingContractMutation } from "../../../../app/services/pendingContractAPI";
import CustomCenterModel from "../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../data/appIcons";
import Contract from "./features/addContract/Contract";
/** Lazy Loading */
const EditPendingContractTab = React.lazy(() => import("./EditPendingContract.tab"));

const EditPendingContract = () => {

  const url = window.location.search;
  const { warning, confirm } = SwalAlert();
  const pendingContractId = new URLSearchParams(url).get("pendingContract");
  const [pendingContractData, setPendingContractData] = useState(null);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const navigate = useNavigate();

  const request = {
    pagination: {
      pageNumber: 1,
      pageSize: 99999
    },
    plPendingContractKey: pendingContractId,
    pbIncludeInactive: true,
    psPendingContractName: null,
  };

  const [getPendingContractsList, {
    isLoading: isPendingContractsLoding,
    isSuccess: isPendingContractsFetching,
    data: pendingContractsData
  }] = useGetPendingContractsListMutation();

  const [updatePendingContract, {
    isSuccess: isupdatePendingContractSuccess,
    data: updatePendingContractData,
  },] = useUpdatePendingContractMutation();

  const [deletePendingContract, {
    isSuccess: deletePendingContractDepartmentFetching,
    data: deletePendingContractDepartmentData
  }] = useDeletePendingContractMutation();

  useEffect(() => {
    if (deletePendingContractDepartmentFetching && deletePendingContractDepartmentData) {
      if (deletePendingContractDepartmentData) {
        ToastService.success(deletePendingContractDepartmentData?.errorMessage);
        handleCloseClick();
      }
    }
  }, [deletePendingContractDepartmentFetching, deletePendingContractDepartmentData])

  useEffect(() => {
    if (isupdatePendingContractSuccess && updatePendingContractData) {
      if (updatePendingContractData) {
        ToastService.success(updatePendingContractData?.errorMessage);
        handleCloseClick();
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isupdatePendingContractSuccess, updatePendingContractData])

  useEffect(() => {
    if (pendingContractId) {
      getPendingContractsList(request);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingContractId]);

  useEffect(() => {
    if (!isPendingContractsLoding && isPendingContractsFetching && pendingContractsData) {
      setPendingContractData(pendingContractsData?.dataSource[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPendingContractsLoding, isPendingContractsFetching, pendingContractsData])


  const handleSaveClick = (data) => {
    setIsSaveClicked(!isSaveClicked);
    if (!data) return;
    const termMonths = Number(data?.dtContractTermMonth);
    if (!Number.isInteger(termMonths) || termMonths <= 0) {
      warning('Please enter a valid number for Term Months.');
      return;
    }
    const request = {
      plPendingContractKey: pendingContractId,
      psPendingContractAddr1: data?.sShipAddr1,
      psPendingContractAddr2: data?.sShipAddr2,
      psPendingContractCity: data?.sShipCity,
      psPendingContractState: getDropdownValue(data?.sShipState),
      psPendingContractZipCode: data?.sShipZip,
      psPendingContractCountry: data?.sPendingContractCountry,
      psPendingContractPhoneVoice: data?.psPendingContractPhoneVoice,
      psPendingContractPhoneFax: String(data?.sContractFaxNumber),
      plContractTypeKey: getDropdownValue(data?.lContractTypeKey),
      plSalesRepKey: getDropdownValue(data?.lSalesRepKey),
      psStatus: data?.status,
      plUserKey: data?.lUserKey,
      plPendingContractAgreementTemplateKey: getDropdownValue(data?.lPendingContractAgreementTemplateKey),
      plTermMonths: data?.dtContractTermMonth,
    };
    updatePendingContract(request);
  };

  const handleDeleteClick = () => {
    confirm(
      "You are about to delete this pending contract",
      "Do you wish to continue?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deletePendingContract(pendingContractId);
      }
    });
  };

  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
  };

  const handalSuccessModel = () => {
    handleCloseModel();
    navigate(`/Contracts/Open`);
  }

  const handleCloseClick = () => {
    navigate(`/Contracts/Open`);
  };
  const handleActionClick = (action) => {
    switch (action) {
      case "SAVE":
        handleSaveClick();
        break;
      case "CLOSE":
        handleCloseClick();
        break;
      case "DELETE":
        handleDeleteClick();
        break;
      case "CREATE CONTRACT":
        setIsModelOpen(true);
        break;
      default:
        break;
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="top-action">
            <div className="left-action-btns">
              <ToolbarButtons
                toolbarConfiguration={pendingContractToolbarConfig}
                onActionClick={handleActionClick}
              />
            </div>
            <div className="right-info-sec d-flex gap-5">
              <div>
                <Label labelName={pendingContractData?.sPendingContractName1 || ''}></Label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contarct-maintenance-page mt-2">
        <PendingContractProvider>
          <EditPendingContractTab
            isClicked={isSaveClicked}
            onSaveClick={handleSaveClick}
          />
        </PendingContractProvider>
      </div>
      
      <CustomCenterModel
          isOpen={isModelOpen}
          useCustomBg={true}
          modalTitle={"Convert Pending Contract to Contract"}
          contentClass="content-50"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
        >
         <Contract  onClose={handleCloseModel} onSuccess={handalSuccessModel}  pendingContractData={pendingContractData} />
        </CustomCenterModel>
    </>
  );
};

export default EditPendingContract;
